var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDriverFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 125",
    style: {
      enableBackground: "new 0 0 125 125"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#939393;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:13;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#939393;stroke-width:11;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 62.5,
    cy: 35.64,
    rx: 21.85,
    ry: 21.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.23,91.45h-0.69c-1.92,0-3.47-1.55-3.47-3.47v-9.16c0-1.92,1.55-3.47,3.47-3.47h0.69 c1.92,0,3.47,1.55,3.47,3.47v9.16C110.7,89.9,109.15,91.45,107.23,91.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.62,91.45h-0.69c-1.92,0-3.47-1.55-3.47-3.47v-9.16c0-1.92,1.55-3.47,3.47-3.47h0.69 c1.92,0,3.47,1.55,3.47,3.47v9.16C22.09,89.9,20.54,91.45,18.62,91.45z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.65,109.32v-2.53c0-22.31,19.22-40.47,42.85-40.47c23.63,0,42.85,18.15,42.85,40.47v2.53H19.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.81,106.79H22.19c0-20.95,18.05-37.93,40.31-37.93S102.81,85.84,102.81,106.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.27,108.65c0-9.44,7.72-17.1,17.23-17.1s17.23,7.65,17.23,17.1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.6,
    y: 78.84,
    transform: "matrix(0.6685 0.7437 -0.7437 0.6685 95.5967 -30.7986)",
    className: "st0",
    width: 9.5,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.22,
    y: 78.13,
    transform: "matrix(-0.6685 0.7437 -0.7437 -0.6685 139.7827 120.8016)",
    className: "st0",
    width: 9.5,
    height: 26.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.19,106.79"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M111.86,84.19c0.22-0.03,0.53-0.05,0.92-0.05c2.2,0,9.38,0.96,9.38,13.36c0,11.88-6.67,13.24-9.01,13.35 l-0.05,0.01l-0.21,0H97.39c-3.02,0-5.48-2.46-5.48-5.48v-0.42c0-1.35,0.49-2.6,1.31-3.55c-0.82-0.96-1.31-2.2-1.31-3.55v-0.51 c0-1.36,0.49-2.6,1.31-3.55c-0.82-0.96-1.31-2.2-1.31-3.55v-0.55c0-3.02,2.46-5.48,5.48-5.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.62,97.49c0-12.23-7.58-10.77-7.58-10.77H97.39c-1.63,0-2.94,1.32-2.94,2.94v0.55 c0,1.63,1.32,2.94,2.94,2.94h14.64v1.22H97.39c-1.63,0-2.94,1.32-2.94,2.94v0.51c0,1.63,1.32,2.94,2.94,2.94h14.64v1.22H97.39 c-1.63,0-2.94,1.32-2.94,2.94v0.42c0,1.63,1.32,2.94,2.94,2.94h15.49c0.01,0,0.02,0,0.02,0 C114.9,108.27,119.62,107.15,119.62,97.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.61,110.85c3.02,0,5.48-2.46,5.48-5.48v-0.42c0-1.35-0.49-2.6-1.31-3.55c0.82-0.96,1.31-2.2,1.31-3.55 v-0.51c0-1.36-0.49-2.6-1.31-3.55c0.82-0.96,1.31-2.2,1.31-3.55v-0.55c0-3.02-2.46-5.48-5.48-5.48H13.14 c-0.22-0.03-0.53-0.05-0.92-0.05c-2.2,0-9.38,0.96-9.38,13.36c0,11.88,6.67,13.24,9.01,13.35l0.05,0.01l0.21,0H27.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.38,97.49c0-12.23,7.58-10.77,7.58-10.77h14.64c1.63,0,2.94,1.32,2.94,2.94v0.55 c0,1.63-1.32,2.94-2.94,2.94H12.96v1.22h14.64c1.63,0,2.94,1.32,2.94,2.94v0.51c0,1.63-1.32,2.94-2.94,2.94H12.96v1.22h14.64 c1.63,0,2.94,1.32,2.94,2.94v0.42c0,1.63-1.32,2.94-2.94,2.94H12.11c-0.01,0-0.02,0-0.02,0C10.1,108.27,5.38,107.15,5.38,97.49z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDriverFound);
export default __webpack_public_path__ + "static/media/no_driver_found.ddaa6514f88f6dc24688ff9f4dbb7a6b.svg";
export { ForwardRef as ReactComponent };